import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import releaseNewsActions from '../../Actions/releaseNewsActions';
import helpers from '../../Utils/helpers';
import { useAppDispatch } from '../../Store/types';
import routes from '../../Constants/routes';
import { ReleaseSeverity } from '../../Constants/releaseSeverity';
import { NEW_RELEASE_NEWS_ID, type RootState } from './ReleaseNews.types';

const ReleaseNewsContainer = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const releaseNews = useSelector((state: RootState) => state.SettingsReducer.releaseNews);

    useEffect(() => {
        void dispatch(releaseNewsActions.getAll());
    }, [dispatch]);

    const openItem = (itemId: string | undefined) => {
        if (itemId === NEW_RELEASE_NEWS_ID) {
            dispatch(
                releaseNewsActions.startNew({
                    title: '',
                    publishDate: new Date().toISOString(),
                    content: '',
                    severity: ReleaseSeverity.Minor,
                    summary: '',
                })
            );
        } else if (itemId !== undefined) {
            void dispatch(releaseNewsActions.get(itemId));
        }
        Promise.resolve(navigate(routes.releaseNewsEdit(itemId))).catch(() => {});
    };

    if (!releaseNews) {
        return null;
    }

    return (
        <div>
            <div className="mb-8">
                <button className="btn btn-primary btn-sm" onClick={() => openItem(NEW_RELEASE_NEWS_ID)}>
                    {t('releasenews.addnew')}
                </button>
            </div>
            <table className="table table-stripe table-hover">
                <thead>
                    <tr>
                        <th>{t('releasenews.title')}</th>
                        <th>{t('releasenews.published')}</th>
                        <th>{t('releasenews.severity')}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {releaseNews.map((item, index) => (
                        <tr key={index} onClick={() => openItem(item.id)}>
                            <td>{item.title}</td>
                            <td>{helpers.formatDate(item.publishDate)}</td>
                            <td>{item.severity === ReleaseSeverity.Major ? t('releasenews.major') : t('releasenews.minor')}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ReleaseNewsContainer;
